<template>
  <div class="help-popup">
    <span
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
    v-html="InfoIconHelp()"
  />
  <transition name="bounce">
    <div
      v-if="isShowPopupInfo"
      :style="popupStyle"
    >
      <BBPopupInfo
        :text="text"
        :custom-class="addClassPopup"
      />
    </div>
  </transition>
  </div>
</template>

<script>
import { InfoIconHelp } from '@/constants/icon'
import BBPopupInfo from "../../../../Main/BBPopupInfo/BBPopupInfo.vue";

export default {
  name: "HelpPopup",
  data:() => ({
    popupStyle: {},
    isShowPopupInfo: false,
    InfoIconHelp,
  }),
  props: {
    text: {
      type: String,
      default: ''
    },
    addClassPopup: {
      type: String,
      default: ''
    },
  },
  components: {
    BBPopupInfo
  },
  methods: {
    onMouseEnter ({target}) {
      this.isShowPopupInfo = true
      this.createPositionPopup(target)
    },
    onMouseLeave () {
      this.isShowPopupInfo = false
    },
    createPositionPopup (target) {
      const {top, height, left, width} = target.getBoundingClientRect()
      this.popupStyle = {
        position: 'fixed',
        top: `${top + height + 10}px`,
        left: `${left + (width / 2)}px`,
        zIndex: 1,
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

.help-popup {
  display: inline-block;
  position: relative;
  top: 2px;
  margin-left: 5px;
  color: $color-denim;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/Companies/CompanyForm/HelpPopup/HelpPopup.vue